// extracted by mini-css-extract-plugin
module.exports = {"price":"invoicerecapitulationitem_price__1c3ps","taxablePrice":"invoicerecapitulationitem_taxablePrice__2TTNn"};